import React from "react";
import { NextSeo } from "next-seo";

const Seo = ({
  title = "Auckland Rescue | Online Shopping Made Better",
  description = "A socially conscious online shopping destination where Shoppers, Good Causes and Retailers all do better! All of our products are at our Retailers’ best prices and we make a donation to a Good Cause of your choice every time you shop with us (out of our pocket, not yours).",
  keywords = "marketplace",
  url = "",
}) => {
  url = `${process.env.SITE_URL}${url}`;
  return (
    <NextSeo
      title={title}
      description={description}
      keywords={keywords}
      openGraph={{
        url,
        title,
      }}
    />
  );
};

export default React.memo(Seo);
